import {useTranslation} from "react-i18next";
import {NS} from "~/enums";

export const useCfdPayoutTypeTranslations = () => {
  const { t } = useTranslation()

  const payoutTypesTranslationMappings: {
    [key: number]: {
      label: string
      description: string
    }
  } = {
    1: {
      label: t('classic', { ns: NS.CHALLENGES, defaultValue: 'Classic' }),
      description: t('classic_program_description', { ns: NS.CHALLENGES }),
    },
    2: {
      label: t('prime', { ns: NS.CHALLENGES, defaultValue: 'Prime' }),
      description: t('prime_program_description', { ns: NS.CHALLENGES }),
    },
    3: {
      label: t('prime_instant', { ns: NS.CHALLENGES, defaultValue: 'Instant' }),
      description: t('prime_instant_program_description', {
        ns: NS.CHALLENGES,
        defaultValue: 'Prime instant program description',
      }),
    },
  }

  return {
    payoutTypesTranslationMappings,
  }
}
